module.exports = __webpack_public_path__ + "static/media/Biomes_card_bg_05.80877125.jpg";